<div
  class="filter"
  [class.filter--no-border]="noBorderTop"
  [class.filter--border-bottom]="borderBottom">
  <div class="filter__title">
    <h4>
      <span>
        <!-- @if (icon) {
          <img
            alt="filter icon"
            [src]="icon" />
        } @else {
          <div class="filter__title__empty"></div>
        } -->
        <div>
          {{ filterTitle | i18next }}
          @if (type === 'checkbox-list') {
            <small
              class="filter__active-filters"
              [ngClass]="{ 'filter__active-filters--black': searchFilters?.length }">
              {{ 'filter.active-filters' | i18next }}
              <span class="not-read-pin">{{ searchFilters?.length || 0 }}</span></small
            >
          }
        </div></span
      >
      @if (maxFilters < filters?.length) {
        <button
          class="sharry-simple sharry-simple--show-all"
          (click)="onToggleMaxFilters()">
          {{ (_maxFilters === filters?.length ? 'filter.show-less' : 'filter.show-all') | i18next }}
          <sharry-icon
            svgClass="svg-icon caret"
            [name]="_maxFilters === filters?.length ? 'caret-up' : 'caret-down'"></sharry-icon>
        </button>
      }
    </h4>
    <!-- @if (!!dateRange && type === 'calendar') {
      <small class="filter__active-filters filter__active-filters--margin-left">
        {{ 'filter.active-filters' | i18next }}
      </small>
    } -->
    @if (type === 'slider') {
      <small class="filter__active-filters filter__active-filters--black">
        {{ 'filter.active-filters' | i18next }} {{ distance }} Km</small
      >
    }
  </div>

  <div class="filter__filter-container">
    @if (_maxFilters === filters?.length) {
      @if (!!searchFilters?.length && type === 'checkbox-list') {
        <button
          class="sharry-simple"
          (click)="onClearList()">
          {{ 'filter.unselect-all' | i18next }}
        </button>
      }
      @if (!searchFilters?.length && type === 'checkbox-list') {
        <button
          class="sharry-simple"
          (click)="onSelectAllList()">
          {{ 'filter.select-all' | i18next }}
        </button>
      }
    }
    @switch (type) {
      @case ('checkbox-list') {
        @for (filter of filters | slice: 0 : _maxFilters; track filter) {
          <mat-checkbox
            color="primary"
            [labelPosition]="'before'"
            [checked]="searchFilters?.includes(filter.id)"
            [value]="filter.id"
            (change)="onCheckboxClick(filter, $event.checked)">
            <section style="display: flex; align-items: center">
              @if (!!filter?.icon?.url) {
                <div
                  class="filter__filter-container__img"
                  [style.backgroundImage]="'url(' + filter.icon.url + ')'"></div>
              }
              <span [innerHTML]="filter.text || filter.name | i18next"></span>
            </section>
          </mat-checkbox>
        }
      }
      @case ('calendar') {
        <sharry-range-calendar
          [dateRange]="dateRange"
          [isTime]="false"
          [isInModal]="true"
          [minDate]="today"
          [startAt]="dateRange?.start || today"
          (selectedChange)="dateRangeChange.emit($event)">
        </sharry-range-calendar>
        <button
          mat-stroked-button
          color="primary"
          class="sharry-small filter-button"
          (click)="onCleanFilter()">
          {{ 'filter.reset-date-filters--for-real' | i18next }}
        </button>
      }
      @case ('slider') {
        <mat-slider
          thumbLabel
          color="primary"
          step="10"
          min="10"
          max="300"
          [displayWith]="formatLabel"
          ><input
            matSliderThumb
            [value]="distance"
            (valueChange)="distanceChange.emit($event)"
        /></mat-slider>
      }
      @default {
        <ng-content></ng-content>
      }
    }
  </div>
</div>
